/** Route heartbeat invalidations only to the affected equipment and operation. */
export function heartbeatTargetsEquipment(data: any, operation: unknown, equipment: unknown): boolean {
  if (!data || operation == null || equipment == null || data.db !== operation || !Array.isArray(data.ids)) return false;
  return data.ids.some((id: unknown) => id != null && String(id) === String(equipment));
}
